import { HttpClient } from 'core/common/services';
import { FunnelSettingsServiceInterface } from 'core/common/services/funnel-settings/interfaces';
import { isTruthyValue } from 'core/common/utils/isTruthyValue';
import { resolveDisplayLocale } from 'core/common/utils/resolveDisplayLocale';
import { Locales } from 'core/user/entities';
import { LocationService } from 'core/user/services';
import { Offer, OfferContentBase } from '../../entities';
import { OfferMapper } from '../../mappers';
import { GroupedOfferDto } from '../dto';

export class OffersService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly locationService: LocationService,
    private readonly funnelSettingsService: FunnelSettingsServiceInterface,
  ) {}

  async getOffers(offerIds: string[], isLocalized: boolean): Promise<Offer[]> {
    if (!offerIds.length) {
      return [];
    }

    // Locales.US keeps the old v1 prices for flows without `localizeOffers: true`.
    // Remove it when we roll out localized offers for everyone.
    const country = isLocalized ? this.locationService.getCountry() : Locales.US;
    const locale = this.funnelSettingsService.getFunnelLocale();
    const mapper = new OfferMapper(resolveDisplayLocale(locale, country));

    const { data } = await this.httpClient.get<GroupedOfferDto[]>(
      '/offer-service/offer/grouped-offer',
      {
        params: {
          'filter[name]': offerIds.join(','),
        },
        headers: {
          country,
          locale,
        },
      },
    );

    return data.map(mapper.toEntity).filter(isTruthyValue);
  }

  matchOffersWithContent<TContent extends OfferContentBase>(
    offers: Offer[],
    contentOffers?: Array<TContent>,
  ) {
    const mapper = new OfferMapper();

    return mapper.matchOffersWithContent(offers, contentOffers);
  }
}
